

export const GET_CSV_REPORT_REQUEST = 'GET_CSV_REPORT_REQUEST';
export const GET_CSV_REPORT_SUCCESS = 'GET_CSV_REPORT_SUCCESS';
export const GET_CSV_REPORT_FAILED = 'GET_CSV_REPORT_FAILED';

export const GetCsvReportAction = (data: any) => {
    return { type: GET_CSV_REPORT_REQUEST, payload: data };
};